'use client';

import { useEffect, useState } from 'react';
import { Box } from '@terra/ui-styled-system';
import { findingsClient } from '@terra/shared-rest-clients-findings';

type FindingPocImagePreviewProps = {
  findingId?: string;
  imageId: string;
  alt: string;
};

export function FindingPocImagePreview({
  findingId,
  imageId,
  alt,
}: FindingPocImagePreviewProps) {
  const [imageUrl, setImageUrl] = useState<string | undefined>();

  useEffect(() => {
    if (!findingId) {
      setImageUrl(undefined);

      return;
    }

    const abortController = new AbortController();
    const fetchImageUrl = async () => {
      try {
        const response = await findingsClient.getFindingPocImageSignedUrl({
          params: { id: findingId, imageId },
          fetchOptions: { signal: abortController.signal },
        });

        if (abortController.signal.aborted) {
          return;
        }

        if (response.status === 200) {
          setImageUrl(response.body.signedUrl);

          return;
        }

        setImageUrl(undefined);
      } catch {
        if (!abortController.signal.aborted) {
          setImageUrl(undefined);
        }
      }
    };

    void fetchImageUrl();

    return () => {
      abortController.abort();
    };
  }, [findingId, imageId]);

  if (!imageUrl) {
    return null;
  }

  return (
    <Box overflow="hidden" borderRadius="md">
      <img
        src={imageUrl}
        alt={alt}
        style={{
          maxWidth: '100%',
          margin: '0 auto',
          height: 'auto',
          display: 'block',
        }}
      />
    </Box>
  );
}
